/* eslint-disable no-console,no-undef,camelcase */
import React from 'react';
import {ChampionTab, CardContainer} from '../ChampionSectionV2/styles';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import {UserCard} from '../ChampionSectionV2/styles'
import { ImageUrl } from '../../utils/constants';
import { NameInitials } from "../Manager/styles";
import {getInitials} from '../../utils/methods'
class WellnessAdmins extends React.Component {

  showUserCards = (data) => (
    data.map((data, index) => (
      <UserCard key={index}>
        {
          data?.profile_image !== "profile-Image/default.png" ? ( <div className="image"> <img src={`${ImageUrl}/${data.profile_image}`} alt={data.name} /> </div> ):
            <div className='image'><NameInitials isSize="24px" isWidth="80px" isHeight="80px" id="name-initials">{getInitials(data?.name)}</NameInitials></div> 
        }
        <div className='name'>{data?.name}</div>
        <div className='department'>{data?.department||"NA"}</div>
        <div className='location'>{data?.location||"NA"}</div>
        <div className='wellnes-wrap'>
          {data && data?.interests.slice(0, 5).map((item, index) => (
            <img src={ImageUrl + "/" + item.interest_icon} alt="no-image" key={index}/>
          ))}
        </div>
        <div className='points'>Wellness Points : {data?.total_wellness_point?data?.total_wellness_point:"0"}</div>
      </UserCard>
    ))
  )

  render() {
    const {wellnessAdmin} = this.props;
    return(
      <ChampionTab style={{width:"1246px",margin:"auto"}}>
        <div>
          {isEmpty(wellnessAdmin) ?
            <CardContainer >
              <h3>No wellness Admins found</h3>
            </CardContainer> : null}
          <CardContainer style={{gap:"20px 31px", marginBottom:"20px"}}>
            {isEmpty(wellnessAdmin) ? '' : wellnessAdmin.map((admin, index) => isEmpty(admin) ? <CardContainer key={index}>
              <h3>No wellness Admins found</h3>
            </CardContainer> : this.showUserCards(admin) )}
          </CardContainer>
        </div>
      </ChampionTab>
    );
  }
}

WellnessAdmins.propTypes = {
  wellnessAdmin: PropTypes.array,
};

export default WellnessAdmins;